
            const data = {"name":"feather/users","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"/><circle pid=\"1\" cx=\"9\" cy=\"7\" r=\"4\"/><path pid=\"2\" d=\"M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                